// src/pages/UserAchievements.js (Z VAŠÍ POSLEDNÍ NAHRANÉ VERZE - BEZ ZMĚN)
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../components/AuthContext';
import AchievementCard from '../components/AchievementCard';
import userService from '../services/userService';
import { useTranslation } from 'react-i18next';
import '../styles/UserAchievements.css';

const UserAchievements = () => {
	const { isLoggedIn, userId } = useContext(AuthContext);
	const [userAchievements, setUserAchievements] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (!isLoggedIn || !userId) {
			setError(t('loginRequired'));
			setLoading(false);
			return;
		}

		const fetchUserAchievements = async () => {
			try {
				const data = await userService.getUserAchievements(userId);
				setUserAchievements(data);
			} catch (err) {
				console.error("Failed to fetch user achievements:", err);
				setError(t('failedToLoadAchievements'));
			} finally {
				setLoading(false);
			}
		};

		fetchUserAchievements();
	}, [isLoggedIn, userId, t]);

	if (loading) {
		return <div className="loading-spinner">{t('loadingAchievements')}</div>;
	}

	if (error) {
		return <div className="error-message">{error}</div>;
	}

	const sortedAchievements = [...userAchievements].sort((a, b) => {
		if (a.completed && !b.completed) return -1;
		if (!a.completed && b.completed) return 1;
		return 0;
	});
	
	return (
		<div className="achievements-page-container">
			<section className="all-achievements">
				<h2>{t('yourAchievements')}</h2>
				<div className="achievement-list">
					{sortedAchievements.map(ua => (
						<AchievementCard key={ua.id} userAchievement={ua} />
					))}
				</div>
			</section>

			{userAchievements.length === 0 && (
				<p className="no-achievements-yet">{t('noAchievementsYet')}</p>
			)}
		</div>
	);
};

export default UserAchievements;